import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PreviewPage } from './preview.page';
import { ShopDetailSharedModule } from '../shared/shop-detail-shared.module';
import { PhoneModalComponent } from '../../shared/phone-modal/phone-modal.component';
import { IonIntlTelInputModule } from 'ion-intl-tel-input';

const routes: Routes = [
  {
    path: '',
    component: PreviewPage
  }
];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ShopDetailSharedModule,
    IonIntlTelInputModule
  ],
  declarations: [PreviewPage],
  entryComponents: [PhoneModalComponent]
})
export class PreviewPageModule {}
